export default {
  dba_motion_capture: 'Motion Capture',
  dba_motion_capture_preview: 'Preview',
  dba_motion_capture_original_video: 'Original video',
  dba_motion_capture_new_video: 'New video',
  dba_motion_capture_uploader_placeholder_text1: 'Click or drag mov, mp4 files to this area to upload.',
  dba_motion_capture_uploader_placeholder_text2: 'It is recommended to upload videos of 15 seconds in length.',
  dba_motion_capture_uploader_footer_text: 'Supports uploading multiple mov, mp4 files at once',
  dba_motion_capture_release_the_mouse: 'Release the mouse',
  dba_motion_capture_some_examples: 'Some Examples',
  dba_motion_capture_file_uploading: 'File uploading...',
  dba_motion_capture_file_processing: 'File processing...',
  dba_motion_capture_file_waitting_tips: '视频处理异步生产，请耐心等待10-15分钟。',
  dba_motion_capture_download_new_video: 'Download new video',
  dba_motion_capture_download_comparison_video: 'Download comparison video',
  dba_motion_capture_delete_tips: 'Are you sure you want to delete {name}?',
  dba_motion_capture_upload_files_single_count_tips: 'Up to {max} file can be uploaded at once',
  dba_motion_capture_upload_files_multiple_count_tips: 'Up to {max} files can be uploaded at once',
  dba_motion_capture_upload_files_type_tips: 'Uploaded file type ({mimeType}) not allowed.',
  dba_motion_capture_upload_files_unknow_error_tips: 'Upload failed',
};
